import { Icon, IconProps } from './Icon';

export const DrivingRoadRulesIcon = ({ color = 'currentColor', ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      d="M4 19L8 5M16 5L20 19M12 8V6M12 13V11M12 18V16"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
